import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { EditLetterDetailsFormDrawer } from 'assets/js/pages/engage/letters/EditLetterDetailsFormDrawer';
import { LetterDetails } from 'assets/js/pages/engage/letters/LetterDetails';
import { LetterDraftRouter } from 'assets/js/pages/engage/letters/LetterDraftRouter';
import { LettersIndex } from 'assets/js/pages/engage/letters/LettersIndex';
import { MailingRetryLetterDrawer } from 'assets/js/pages/engage/letters/MailingRetryLetterDrawer';
import { MailingTransactionsDrawer } from 'assets/js/pages/engage/letters/MailingTransactionsDrawer';
import { DrawerRoute } from 'components/drawer-route';
import { handleRateLimitError } from 'components/error-boundaries/RateLimitErrorBoundary';
import { Route } from 'components/router/Route';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LettersRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route path={`${match.path}/:letter_id(\\d+)`} component={WrappedLetterDetails} />
            <Route path={`${match.path}/draft/:letter_id/edit`} component={WrappedLetterDraft} />
            <Route path={match.path}>
                {({ match }) => (
                    <>
                        <DrawerRoute
                            path={`${match?.path}/details/:letter_id/edit`}
                            component={EditLetterDetailsFormDrawer}
                        />
                        <Switch>
                            <Route path={match?.path} component={LettersIndex} />
                        </Switch>
                    </>
                )}
            </Route>
        </Switch>
    );
};

const WrappedLetterDetails = () => {
    const match = useRouteMatch();
    const { accountId } = useCurrentAccount();

    return (
        <ErrorBoundary
            onError={handleRateLimitError}
            fallback={<Redirect to={`/accounts/${accountId}/engage/letters`} />}
        >
            <DrawerRoute path={`${match.path}/edit`} component={EditLetterDetailsFormDrawer} />
            <DrawerRoute
                path={`${match.path}/mailings/:mailpiece_id(\\d+)/transactions`}
                component={MailingTransactionsDrawer}
            />
            <DrawerRoute
                path={`${match.path}/mailings/:mailpiece_id(\\d+)/retry`}
                component={MailingRetryLetterDrawer}
            />
            <Switch>
                <Route path={match.path} component={LetterDetails} />
            </Switch>
        </ErrorBoundary>
    );
};

const WrappedLetterDraft = () => {
    const { accountId } = useCurrentAccount();

    return (
        <ErrorBoundary
            onError={handleRateLimitError}
            fallback={<Redirect to={`/accounts/${accountId}/engage/letters`} />}
        >
            <LetterDraftRouter />
        </ErrorBoundary>
    );
};

export default LettersRouter;
